import { Row, Container, Button, Modal, Form } from "react-bootstrap";
import React, { useState } from "react";
import "assets/css/Loaders/scriptLoader.css";
import {useSelector} from "react-redux";

export default function Settings() {
  const [loader, setLoader] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const user = useSelector((state) => state.authReducer.data);

  const handleIframeLoad = () => {
    setLoader(false);
  };

  const handleShowModal = () => setShowModal(true);
  const handleSubmitModal = () => {
    alert("THIS IS IN PRODUCTION RIGHT NOW");
    setShowModal(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <Container fluid>
      <Row className={"mt-5"}>
        <div
          className={"d-flex justify-content-between align-items-center w-100"}
        >
          <h4 className="main-h4-tag-large">Inbound Calling Script</h4>
          <Button className={"custom-button"} onClick={handleShowModal}>
            Request for Change
          </Button>
        </div>
        <div className="iframe-container">
          {loader && (
            <div className="loader-scriptLoader">
              <div className="wrapper">
                <div className="circle"></div>
                <div className="line-1"></div>
                <div className="line-2"></div>
                <div className="circle-2"></div>
                <div className="line-3"></div>
                <div className="line-4"></div>
                <div className="circle-3"></div>
                <div className="line-5"></div>
                <div className="line-6"></div>
                <div className="circle-4"></div>
                <div className="line-7"></div>
                <div className="line-8"></div>
                <div className="circle-5"></div>
                <div className="line-9"></div>
                <div className="line-10"></div>
                <div className="circle-6"></div>
                <div className="line-11"></div>
                <div className="line-12"></div>
                <div className="circle-7"></div>
                <div className="line-13"></div>
                <div className="line-14"></div>
                <div className="circle-8"></div>
                <div className="line-15"></div>
                <div className="line-16"></div>
                <div className="circle-9"></div>
                <div className="line-17"></div>
                <div className="line-18"></div>
                <div className="circle-10"></div>
                <div className="line-19"></div>
                <div className="line-20"></div>
              </div>
            </div>
          )}
          <iframe
            width="100%"
            height="700px"
            src={`https://zbahsuhcgh.us-east-1.awsapprunner.com/viewer?accountID=${user?.accountID}`}
            onLoad={handleIframeLoad}
            style={{ display: loader ? "none" : "block" }}
          ></iframe>
        </div>
      </Row>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Schedule Meeting</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formDate">
              <Form.Label>Date</Form.Label>
              <Form.Control type="date" />
            </Form.Group>
            <Form.Group controlId="formTime">
              <Form.Label>Time</Form.Label>
              <Form.Control type="time" />
            </Form.Group>
            <Form.Group controlId="formAttendees">
              <Form.Label>Attendees</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter email addresses separated by commas"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className={"d-flex justify-content-between"}>
          <Button style={{background : "red"}} onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button style={{background : "green"}} onClick={handleSubmitModal}>
            Schedule
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}
